module.exports = __webpack_public_path__ + "static/media/frog_specification_en.9e67b1e5.md";